export default {"src":"/_next/static/media/CA.f80d8b08.svg","height":355,"width":512,"blurWidth":0,"blurHeight":0};